export enum DBRole {
    USER = 'USER',
    ADMIN = 'ADMIN',
    TEAMLEADER = 'TEAMLEADER',
    SUPERADMIN = 'SUPERADMIN',
    GUEST = 'GUEST',
    NOROLE = 'NOROLE',
}



export enum DBAuthRole {
    USER = 'USER',
    ADMIN = 'ADMIN',
    TEAMLEADER = 'TEAMLEADER',
    SUPERADMIN = 'SUPERADMIN',
    GUEST = 'GUEST',
    ALL = 'ALL',
    TEAMLEADER_AND_UP = 'TEAMLEADER_AND_UP',
    USER_AND_UP = 'USER_AND_UP',
}

export enum DBMutationType {
    INSERT = 'INSERT',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    RESET = 'RESET',
    ARCHIVE = 'ARCHIVE',
    RESTORE = 'RESTORE',
    CLONE = 'CLONE',
    DISABLE = 'DISABLE',
    ENABLE = 'ENABLE',
}



export enum DBModelOwner {
    USER = 'USER',
    COMPANY = 'COMPANY',
    NOTDEFINED = 'NOTDEFINED',
    COLOR = 'COLOR',
    PRODUCTMODEL = 'PRODUCTMODEL',
    PANTONE = 'PANTONE',
    PANTONECOLOR = 'PANTONECOLOR',
    PANTONEPRODUCTMODEL = 'PANTONEPRODUCTMODEL',
    OPTIONAL = 'OPTIONAL',
    OPTIONALDETAIL = 'OPTIONALDETAIL',
    EDITOR = 'EDITOR',
    CODETABLES = 'CODETABLES',
    ACCESSORY = 'ACCESORY',
    QUOTE = 'QUOTE',

}

export enum DBStatus {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
    DELETED = 'DELETED',
    PENDING = 'PENDING',
    DRAFT = 'DRAFT',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    ARCHIVED = 'ARCHIVED',
}

export enum DBDocStatus {
    NONE = 'NONE',
    DRAFT = 'DRAFT',
    READY = 'READY',
    //SENT = 'SENT',
    //RECEIVED = 'RECEIVED',
    INPROGRESS = 'INPROGRESS',
    ONHOLD = 'ONHOLD',
    COMPLETED = 'COMPLETED',
    CANCELED = 'CANCELED',
    ALL = 'ALL',
}


export enum DBRetCode {
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
    SUCCESS = 'success',
}

export enum DBErrorCode {
    SIGNUP = 'Err_SIGNUP',
    SIGNIN = 'Err_SIGNIN',
    GENERIC = 'Err_GENERIC',
    NOTFOUND = 'Err_NOTFOUND',
    MUTATEUSER = 'Err_MUTATEUSER',
    INVALIDINPUT = 'Err_INVALIDINPUT',
    USERNOTFOUND = 'Err_USERNOTFOUND',
    PROVIDERIDNOTFOUND = 'Err_PROVIDERIDNOTFOUND',
    NOTAUTHORIZED = 'Err_NOTAUTHORIZED',
    GENERICMUTATE = 'Err_GENERICMUTATE',
    UNKNOWNERROR = 'Err_UNKNOWNERROR',
    COMPANYOWNER = 'Err_COMPANYOWNER',
    APP_CHECK = 'Err_APP_CHECK',
    INPUT_VALIDATION = 'Err_INPUT_VALIDATION',
}

export enum DBProcess {
    SIGNIN = 'SIGNIN',
    SIGNINGoogle = 'SIGNINGoogle',
    SIGNUP = 'SIGNUP',
    SETNEWPASSWORD = 'SETNEWPASSWORD',
    SIGNOUT = 'SIGNOUT',
    CREATEUSER = 'CREATEUSER',
    CHANGEPASSWORD = 'CHANGEPASSWORD',
}

export enum DBProviderType {
    GOOGLE = 'GOOGLE',
    FACEBOOK = 'FACEBOOK',
    GITHUB = 'GITHUB',
    MICROSOFT = 'MICROSOFT',
    APPLE = 'APPLE',
}

export enum DBAnalyticsEvents {
    SIGNEDUP = 'Signed Up',
    SIGNEDIN = 'Signed In',
    SIGNEDOUT = 'Signed Out',
    CREATEDUSER = 'Created User',
    MUTATEDUSER = 'Mutated User',
    CREATEDCOMPANY = 'Created Company',
    UPDATEDCOMPANY = 'Updated Company',
    MUTATEPRODUCTMODEL = 'Mutate Product Model',
    LISTPRODUCTMODEL = 'List Product Model',
    LISTATTACHMENT = 'List Attachment',
    LISTCOMPANYUSER = 'List Company User',
    MUTATEATTACHMENT = 'Mutate Attachment',
    GETUSER = 'Get User Data',
    MUTATEDREGISTRY = 'Mutated Registry',
    LISTREGISTRY = 'List Registry',
    LISTCOMPANY = 'List Company',
    LISTCOMPANYLINK = 'List Company Link',
    MUTATECOMPANYLINK = 'Mutate Company Link',


    MUTATECOLOR = 'Mutate Color',
    LISTCOLOR = 'List Color',
    MUTATEPANTONE = 'Mutate Pantone',
    LISTPANTONE = 'List Pantone',
    MUTATEPANTONECOLOR = 'Mutate Pantone Color',
    LISTPANTONECOLOR = 'List Pantone Color',
    MUTATEPANTONEPRODUCTMODEL = 'Mutate Pantone Product Model',
    LISTPANTONEPRODUCTMODEL = 'List Pantone Product Model',
    MUTATEOPTIONAL = 'Mutate Optional',
    LISTOPTIONAL = 'List Optional',
    MUTATEOPTIONALDETAIL = 'Mutate Optional Detail',
    LISTOPTIONALDETAIL = 'List Optional Detail',
    MUTATEPRODUCTMODELOPTIONAL = 'Mutate Product Model Optional',
    LISTPRODUCTMODELOPTIONAL = 'List Product Model Optional',
    LISTMEASURE = 'List Measure',
    MUTATEMEASURE = 'Mutate Measure',
    LISTMEASUREGROUP = 'List Measure Group',
    MUTATEMEASUREGROUP = 'Mutate Measure Group',
    MUTATEPRODUCTMODELMEASUREGROUP = 'Mutate Product Model Measure Group',
    LISTPRODUCTMODELMEASUREGROUP = 'List Product Model Measure Group',
    LISTCODETABLES = 'List Code Tables',
    LISTCODETABLESNAME = 'List Code Tables Name',
    MUTATECODETABLES = 'Mutate Code Tables',
    MUTATECODETABLESNAME = 'Mutate Code Tables Name',
    LISTQUOTE = 'List Quote',
    MUTATEQUOTE = 'Mutate Quote',
    LISTQUOTEVERSION = 'List Quote Version',
    MUTATEQUOTEVERSION = 'Mutate Quote Version',
    LISTQUOTEDETAIL = 'List Quote Detail',
    MUTATEQUOTEDETAIL = 'Mutate Quote Detail',
    LISTQUOTEOPTIONAL = 'List Quote Optional',
    MUTATEQUOTEOPTIONAL = 'Mutate Quote Optional',
    GETQUOTE = 'Get Quote',
    LISTPRODUCTMODELCOLOR = 'List Product Model Color',
    LISTMATERIALTYPECOLOR = 'List Material Type Color',
    LISTPRODUCTMODELOPTIONALDETAIL = 'List Product Model Optional Detail',
    MUTATEQUOTEDETAILOPTIONAL = 'Mutate Quote Detail Optional',
    LISTQUOTEDETAILOPTIONAL = 'List Quote Detail Optional',
    MUTATEOPTIONALDETAILLINK = 'Mutate Optional Detail Link',
    LISTOPTIONALDETAILWITHLINK = 'List Optional Detail With Link',
    LISTACCESSORY = 'List Accessory',
    MUTATEACCESSORY = 'Mutate Accessory',
    LISTQUOTEACCESSORY = 'List Quote Accessory',
    MUTATEQUOTEACCESSORY = 'Mutate Quote Accessory',
    LISTPRICEGROUPMEASURE = 'List Price Group Measure',
    MUTATEPRICEGROUPMEASURE = 'Mutate Price Group Measure',
    LISTPRICEMEASURE = 'List Price Measure',
    MUTATEPRICEMEASURE = 'Mutate Price Measure',
    LISTPRODUCTMODELOPTIONALPRICEGROUPMEASURE = 'List Product Model Optional Price Group Measure',
    MUTATEPRODUCTMODELOPTIONALPRICEGROUPMEASURE = 'Mutate Product Model Optional Price Group Measure',
}

export enum DBRangeDate {
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    LAST7DAYS = 'LAST7DAYS',
    LAST30DAYS = 'LAST30DAYS',
    CURRENTWEEK = 'CURRENTWEEK',
    PREVWEEK = 'PREVWEEK',
    THISMONTH = 'THISMONTH',
    PREVIOUSMONTH = 'PREVIOUSMONTH',
    LAST3MONTHS = 'LAST3MONTHS',
    NEXTMONTH = 'NEXTMONTH',
    ALLDATE = 'ALLDATE',
    CUSTOM = 'CUSTOM',
}

export enum DBCallMethods {
    GET = 'get',
    POST = 'post',
    DELETE = 'delete',
}
export enum DBUUidPrefix {
    ACTIVITY = 'Act_',
    ACCOUNTPROVIDER = 'Acp_',
    APIKEY = 'Apk_',
    ATTACHMENT = 'Atc_',

    COMPANY = 'Cmp_',
    COMPANYLINK = 'Cml_',
    DEFAULT = 'My_',
    DEFAULTSHORT = 'Ms_',

    REGISTRY = 'Reg_',
    SUBSCRIPTIONPLAN = 'Sbp_',

    PRODUCTMODEL = 'Pmd_',
    COLOR = 'Clr_',
    PANTONE = 'Pnt_',
    PANTONECOLOR = 'Pnc_',
    PANTONEPRODUCTMODEL = 'Ppm_',
    OPTIONAL = 'Opt_',
    OPTIONALDETAIL = 'Odt_',
    ACCESSORY = 'Acc_',
    OPTIONALDETAILLINK = 'Odl_',
    PRODUCTMODELOPTIONAL = 'Pmo_',
    MEASURE = 'Msr_',
    MEASUREGROUP = 'Mmg_',
    PRODUCTMODELMEASUREGROUP = 'Pmg_',
    CODETABLES = 'Ctb_',
    CODETABLESNAME = 'Ctn_',

    USER = 'Usr_',
    USERCOMPANY = 'Ucp_',
    NOTDEFINED = 'NOTDEFINED_',

    QUOTE = 'Qte_',
    QUOTEDETAIL = 'QtD_',
    QUOTEOPTIONAL = 'QtO_',
    QUOTEVERSION = 'QtV_',
    QUOTEACCESSORY = 'QtA_',

    PRICEGROUPMEASURE = 'Pgm_',
    PRICEMEASURE = 'Pme_',
    PRODUCTMODELOPTIONALPRICEGROUPMEASURE = 'Pmp_',


}

export enum DBChannel {
    APPWEB = 'APPWEB',
    APIGATEWAY = 'APIGATEWAY',
    NOTDEFINED = 'NOTDEFINED',
}

export enum DBAttachmentType {
    USERPROFILE = 'USERPROFILE',
    COMPANYPROFILE = 'COMPANYPROFILE',
    ATTACHMENT = 'ATTACHMENT',
    DOCUMENT = 'DOCUMENT',
}

export enum DBAuthProfile {
    CLIENT = 'CLIENT',
    MANAGER = 'MANAGER',
    SELLER = 'SELLER',
}
export enum DBLocale {
    IT = 'it',
    EN = 'en',
}

export enum DBStorageType {
    USER = 'USER',
    COMPANY = 'COMPANY',
    PUBLIC = 'PUBLIC',
    MISC = 'MISC',
}

export enum DBMaterialType {
    ALL = 'ALL',
    PVC = 'PVC',
    ALUMINIUM = 'ALUMINIUM',
    WOOD = 'WOOD',
    NONE = 'NONE'
}

export enum DBOptionalType {
    TELAIO = 'TELAIO',
    APERTURA = 'APERTURA',
    CHIUSURA = 'CHIUSURA',
    APPLICAZIONE = 'APPLICAZIONE',
    DOGA = 'DOGA',
    FERRAMENTA_SOSTEGNO_ESTERNA = 'FERRAMENTA_SOSTEGNO_ESTERNA',
    //FERRAMENTA_SOSTEGNO_INTERNA = 'FERRAMENTA_SOSTEGNO_INTERNA',
    CARDINI = 'CARDINI',
    MURATURA = 'MURATURA',
    SPALLA = 'SPALLA',
    CONTROTELAIO = 'CONTROTELAIO',
    FERMASCURI = 'FERMASCURI',
    SOLUZIONE_CHIUSURA_SERRATURA = 'SOLUZIONE_CHIUSURA_SERRATURA',
    SEZIONE_MURO = 'SEZIONE_MURO',
    //OTHER = 'OTHER',
    SIDE4 = 'SIDE4',
    //COLOR = 'COLOR',
    //PANTONE = 'PANTONE',
    //CHIUSURA_SUPERIORE = 'CHIUSURA_SUPERIORE',
    //CHIUSURA_INFERIORE = 'CHIUSURA_INFERIORE',
    //PAREGGIATORE = 'PAREGGIATORE',
    // BATTUTA = 'BATTUTA',
    //ALTEZZA_POSIZIONAMENTO = 'ALTEZZA_POSIZIONAMENTO',
    //  FERMASCURI = 'FERMASCURI',
    // BANDELLE = 'BANDELLE',
    //BORDO = 'BORDO',
    NONE = 'NONE',
}

export enum DBEntryType {
    SINGLEOPTION = 'SINGLEOPTION',
    MULTIOPTION = 'MULTIOPTION',
    SELECTOR = 'SELECTOR',
    CHECKBOX = 'CHECKBOX',
    NONE = 'NONE',
}
export enum DBInputType {
    TEXT = 'TEXT',
    TEXTMANDATORY = 'TEXTMANDATORY',
    NUMBER = 'NUMBER',
    NUMBERMANDATORY = 'NUMBERMANDATORY',
    //  CURRENCY = 'CURRENCY',
    MEASURE = 'MEASURE',
    MEASUREMANDATORY = 'MEASUREMANDATORY',
    QUANTITY = 'QUANTITY',
    QUANTITYMANDATORY = 'QUANTITYMANDATORY',
    //   DATE = 'DATE',
    NONE = 'NONE',
}

export enum DBAxis {
    NONE = 'NONE',
    LARGHEZZA = 'LARGHEZZA',
    ALTEZZA = 'ALTEZZA',
    // PROFONDITA = 'PROFONDITA',
}

export enum DBCurrency {
    EUR = 'EUR',
}

export enum DBSide {
    NONE = 'NONE',
    LEFT = 'LEFT',
    RIGHT = 'RIGHT',
}

export enum DBForcedMeasure {
    NONE = 'NONE',
    SOLUZIONE1 = 'SOLUZIONE1',
    SOLUZIONE2 = 'SOLUZIONE2',
    SOLUZIONE3 = 'SOLUZIONE3'
}

export enum DBQuoteDetailType {
    NONE = 'NONE',
    WINDOW = 'WINDOW',
    DOOR = 'DOOR'
}

export enum DBCodeTable {
    VATLIST = 'VATLIST',
    OPTIONAL_DETAIL = 'OPTIONAL_DETAIL',
    SOLUZIONI = 'SOLUZIONI',
    MEASURE = 'MEASURE',
    TRANSPORT_LOCATION = 'TRANSPORT_LOCATION'
}

export enum DBYESNOOptional {
    YES = 'YES',
    OPTIONAL = 'OPTIONAL',
    NO = 'NO',

}

export enum DBParamType {
    NONE = 'NONE',
    SOLUTION = 'SOLUTION'
}

export enum DBRegistryType {
    NONE = 'NONE',
    CLIENT = 'CLIENT',

}

export enum DBTransportType {
    NONE = 'NONE',
    COMPANY = 'COMPANY',
    CLIENT = 'CLIENT'
}

export enum DBDimensionType {
    NONE = 'NONE',
    MEASURE_HOLE = 'MEASURE_HOLE',
    MEASURE_SHUTTERS = 'MEASURE_SHUTTERS'
}

export enum DBHandle {
    NONE = 'NONE',
    F500 = 'F500',
    PF1000 = 'PF1000',
    HALF = 'HALF',
    OTHER = 'OTHER'
}

export enum DBQuoteType {
    NONE = 'NONE',
    QUOTE = 'QUOTE',
    ORDER = 'ORDER',
    ALL = 'ALL',
}

export enum DBAccessoryType {
    NONE = 'NONE',
    POSA = 'POSA',
    ALL = 'ALL',

}

export enum DBPriceType {
    UNIT = 'UNIT',
    PERCENTAGE = 'PERCENTAGE',
    FIXED = 'FIXED',
    MIXUP = 'MIXUP', //mix unit and percentage
    MIXFP = 'MIXFP', //mix fixed and percentage
    MIXUF = 'MIXUF', //mix unit fixed and percentage
    QUOTE_FIXED = 'QUOTE_FIXED',
    QUOTE_PERCENTAGE = 'QUOTE_PERCENTAGE',
    QUOTE_FIXEDP = 'QUOTE_FIXEDP', //mix fixed and percentage for quote
    NONE = 'NONE',
}

export enum DBCompanyLinkType {
    SELLER_CLIENT = 'SELLER_CLIENT',
    CLIENT_SELLER = 'CLIENT_SELLER',
    SELF = 'SELF',
    NONE = 'NONE',
}